import { BaseService } from 'core/services';
import ImportRouteService from './ImportRouteService';
import moment from 'moment';

class ImportService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImportRouteService());
    }

    async getStatus(){
        const url = this.routeService.getStatus();
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);
        formData.append('facility', resource.facility);  
        
        let scheduledDate = moment(resource.scheduledDate).utc().format('YYYY-MM-DD');
        formData.append('scheduledDate', scheduledDate);

        let dateOfService = moment(resource.dateOfService).utc().format('YYYY-MM-DD');
        formData.append('dateOfService', dateOfService);
        
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }

    async getImportUsers(searchQuery){
        const url = this.routeService.getImportUsers(searchQuery);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
    
	async changeIsFirst(resource) {
        const url = this.routeService.changeIsFirst(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async getPatientsByCategory(filter){
        const url = this.routeService.getPatientsByCategory(filter);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
    
    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }

    getValidationReportUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadValidationReport(filter);
    }

}

export default ImportService;
